export class SetSelectedRouteFromRouteState {
  static readonly type = '[RouteState] Set Selected Route';
  constructor(public route: string) {}
}

export class ResetRouteState {
  static readonly type = '[RouteState] Reset';
}

